import { motion } from 'framer-motion';

const MissionValues = () => {
  const values = [
    {
      icon: 'ri-shield-check-line',
      title: '誠実さ',
      description: 'お客様に対して常に誠実であり、正直で透明性の高いサービスを提供します。',
    },
    {
      icon: 'ri-lightbulb-flash-line',
      title: '専門性',
      description: '常に最新の税務・会計知識を習得し、高度な専門性でお客様をサポートします。',
    },
    {
      icon: 'ri-team-line',
      title: 'パートナーシップ',
      description: 'お客様と対等なパートナーとして、共に課題を解決し、成功を目指します。',
    },
    {
      icon: 'ri-rocket-line',
      title: '成長志向',
      description: 'お客様の事業成長を第一に考え、積極的な提案と実践的なアドバイスを行います。',
    },
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-[1200px] mx-auto px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-5xl font-bold text-gray-900 mb-6">
            私たちの価値観
          </h2>
          <div className="w-24 h-1 bg-red mx-auto mb-6"></div>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            これらの価値観を大切にし、お客様と共に成長していきます
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="group bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-red/20"
            >
              <div className="w-20 h-20 bg-gradient-to-br from-red to-red-light rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform mx-auto">
                <i className={`${value.icon} text-4xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">
                {value.title}
              </h3>
              <p className="text-gray-600 leading-relaxed text-center">
                {value.description}
              </p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6 }}
          className="text-center mt-16"
        >
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSfcI_iqOXmdZhJO8vkCvjObLY5GxPIAQ8kXxWKDFswsKGrSRQ/viewform?usp=publish-editor"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-red text-white px-8 py-4 rounded-full font-medium hover:bg-red/90 transition-colors whitespace-nowrap cursor-pointer"
          >
            <span>お問い合わせ</span>
            <i className="ri-arrow-right-line"></i>
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default MissionValues;
